// CRM 2.0 "Payment successful" pop-up (M2-F9, M2.22, DC-80 / DC-82).
// The portal has no in-app payment callback (payment links / virtual account), so this shows
// once when this browser saw the booking Shortlisted and now sees it paid (Home's realtime
// listener or the next visit).
import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import Close from "../../Icons/Close";
import Button from "../../../Subcomponents/Button";
import { inr } from "./Crm2Parts";
import { WAITRM } from "./useCrm2Booking";
import css from "./Crm2Booking.module.css";

const key = (apId) => `crm2LastState:${apId}`;
const read = (k) => {
	try {
		return localStorage.getItem(k);
	} catch {
		return null;
	}
};
const write = (k, v) => {
	try {
		localStorage.setItem(k, v);
	} catch {
		/* private window: pop-up just won't be remembered */
	}
};

export default function PaymentSuccess({ allotment, info }) {
	const [open, setOpen] = useState(false);
	const apId = info?.allotmentPaymentId;
	const state = info?.bookingState;

	useEffect(() => {
		if (!apId || !state || state === "OTHER") return;
		const before = read(key(apId));
		if (before === "SHORTLISTED" && state !== "SHORTLISTED") {
			console.log("[crm2][portal] booking amount fully paid, showing Payment successful", apId);
			setOpen(true);
		}
		write(key(apId), state === "SHORTLISTED" ? "SHORTLISTED" : "PAID");
	}, [apId, state]);

	if (!open) return null;
	const waiting = state === "WAITING_RM";
	const items = [
		["Booking amount received", `${inr(allotment?.bookingAmt?.total)} · receipt sent by email`],
		["Unit status: Shortlisted → Applied", waiting ? "Application for Booking starts when your Relationship Manager is assigned" : "Application for Booking starts today"],
		waiting
			? [WAITRM, "Usually within 1 working day. We tell you by email and WhatsApp as soon as they are assigned."]
			: ["Relationship Manager assigned", <><b>{info.crm?.name}</b>{info.crm?.phone ? ` · ${info.crm.phone}` : ""} · guides you until handover</>],
	];
	const unit = [allotment?.unitId?.unitNo ?? allotment?.inventoryMergedId?.unit1Id?.unitNo, info?.projectName].filter(Boolean).join(" · ");

	return (
		<Modal open onClose={() => setOpen(false)} sx={{ ".MuiBackdrop-root": { background: "rgba(52, 64, 84, 0.7)" } }} disableAutoFocus>
			<Box className={css.modal}>
				<div className={css.modalHeader}>
					<span>Payment successful</span>
					<span className={css.modalClose} onClick={() => setOpen(false)} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
				</div>
				<div className={css.modalContent}>
					{unit && <div className={css.unitHead}>{unit}</div>}
					<div className={css.seq}>
						{items.map(([t, s], i) => {
							const wt = waiting && i === 2;
							return (
								<div key={i} className={wt ? css.wt : css.on}>
									<i>{wt ? "…" : "✓"}</i>
									<div>
										<b>{t}</b>
										<span>{s}</span>
									</div>
								</div>
							);
						})}
					</div>
					{waiting ? (
						<div className={css.info}>Next: we assign your Relationship Manager. Then your Application for Booking starts and you fill your Agreement KYC.</div>
					) : (
						<div className={css.good}>Next: fill your Agreement KYC.</div>
					)}
				</div>
				<div className={css.modalFooter}>
					<Button
						btnName="Continue"
						clicked={() => setOpen(false)}
						style={{ color: "#fff", backgroundColor: "rgb(21, 112, 239)", fontSize: "1.4rem", lineHeight: "2rem", fontFamily: "Inter-Medium !important", width: "auto" }}
					/>
				</div>
			</Box>
		</Modal>
	);
}
